module.exports = __webpack_public_path__ + "img/hz_06.d582d0ed.png";